export enum RecommendationAction {
  MOVE_ON = 'MOVE_ON',
  PREREQUISITE_SKILL = 'PREREQUISITE_SKILL',
  COMPLETE_ASSIGNMENT = 'COMPLETE_ASSIGNMENT',
  ADD_SKILL_TUTORING = 'ADD_SKILL_TUTORING',
  ADD_TEACHER_RESOURCE = 'ADD_TEACHER_RESOURCE'
}

export default RecommendationAction; 